var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between"},[_c('h3',{staticClass:"h5"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('small',[_vm._v("\n    "+_vm._s(_vm.selectedCount)+"/"+_vm._s(_vm.totalCount)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./assets/js/components/work-logs/FilterHeader.vue?vue&type=template&id=0cb9df52&
// module id = 101
// module chunks = 0 1